import { request, RespError, handleFormatRes } from '../../utils';
import { QRY_USER_PROFILE } from '../../config/url';
// 需要转成 int 型的 key 数组
const needParseIntKey = [];
// 需要转成 date 型的 key 数组
const needParseDateKey = [];
// 需要转成 bool 型的 key 数组
const needParseBoolKey = ['attrFlag'];
/**
 *
 * 查询用户实时属性
 *
 * 接口地址：`/app/promotion/prom_qry_user_profile.cgi`
 * @param attrName 用户实时属性
 * @returns
 */
export async function qryUserProfile({ attrName }) {
    try {
        // 参数格式化
        const params = {
            t: new Date().getTime(),
            attr_name: attrName,
        };
        // 接口请求
        const result = await request.get(QRY_USER_PROFILE, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({ result, needParseIntKey, needParseDateKey, needParseBoolKey });
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
